import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { IAppState } from '../../../../store/rootDuck';
import { useDefineUserRole } from '../../../../hooks';
import CompanyBind from '../../companies/CompanyBind';

export const NavigateMyProductsCompany = () => {
  const navigate = useNavigate();
  const { me } = useSelector((store: IAppState) => ({
    me: store.profile.me,
  }));
  const isVendor = useDefineUserRole(me, ['ROLE_VENDOR', 'ROLE_VENDOR_STAFF']);

  if (me && !isVendor) {
    navigate('/');
  }
  if (me && isVendor) {
    if (me.company) {
      navigate(`/products/catalog/company/${me.company.id}`);
    } else {
      return <CompanyBind />;
    }
  }

  return null;
};
